<template>
  <div>
    <Calendar v-model="theDate" :showTime="false" :locale="sv" :selectOtherMonths="true" :showButtonBar="true" dateFormat="yy-mm-dd" />
  </div>
</template>
<script>
import { abstractField } from 'vue-form-generator'
import Calendar from 'primevue/calendar'
import moment from 'moment'
import { bus } from '../main'
export default {
  components: {
    Calendar,
    moment,
    bus
  },
  data () {
    return {
      sv: {
        firstDayOfWeek: 1,
        dayNames: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
        dayNamesShort: ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör'],
        dayNamesMin: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
        monthNames: [ 'Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December' ],
        monthNamesShort: [ 'Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec' ],
        today: 'Idag',
        clear: 'Rensa',
        dateFormat: 'yy-mm-dd',
        weekHeader: 'vk'
      }
    }
  },
  mixins: [abstractField],
  computed: {
    theDate: {
      get: function () {
        if (this.value !== undefined && this.value !== null) {
          return new Date(this.value)
        } else {
          return this.value
        }
      },
      set: function (newValue) {
        if (newValue !== null) {
          this.value = moment(newValue).format('YYYY-MM-DD')
          return moment(newValue).format('YYYY-MM-DD')
        }
        bus.$emit('clearDecidedDeliveryDate', true)
        return ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/vfg-custom-fields/fieldFormattedDatePicker.vue